import { GoldDiamond } from "@/components/icons";

const ITEMS = [
  "Tenant Management",
  "Rent Collection",
  "Property Inspections",
  "Make-Ready",
  "Deep Cleaning",
  "Painting & Repairs",
  "Documentation",
  "Owner Reporting",
  "Photo & Video Evidence",
  "Hyderabad",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-7 font-display text-sm font-semibold uppercase tracking-[0.3em] text-white/55 sm:text-base">
          {item}
        </span>
        <GoldDiamond className="h-2 w-2 shrink-0 text-gold-500" />
      </span>
    ))}
  </div>
);

// One slow editorial marquee — full-bleed navy band
export const Marquee = ({ className = "" }) => (
  <div
    className={`relative overflow-hidden border-y border-white/10 bg-navy-950 py-5 ${className}`}
    aria-hidden="true"
  >
    <div className="marquee-track animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
